import { connect } from 'react-redux';
import { Menu,
         Container,
         Dropdown,
         Header,
         Grid,
         Sidebar,
         Icon } from 'semantic-ui-react'


var React = require('react');

const ReactHighcharts = require('react-highcharts');
var Highlight = require('react-highlight');
var ReactDOM = require('react-dom');


class Chart extends React.Component {

    componentDidMount() {
        // let chart = this.refs.chart.getChart();
        // chart.series[0].addPoint({x: 10, y: 12});
      }
   constructor(props) {
     super(props)
     
     ReactHighcharts.Highcharts.setOptions({
       lang: {
         thousandsSep: ','
       }
     })
    }

    render() {
        // console.log(this.props.data,'Charts Data')
        const displayTitle = (title) => {
            if (title) {
                return (
                    <Grid.Row style={styles.heading}>
                        <Header as='h5' style={styles.headingText}>{this.props.title}</Header>
                    </Grid.Row>
                )
            }

            return null
        }
        return (
            <Grid.Column verticalAlign='top'>
                {displayTitle(this.props.title)}
                <div className='pieChartInner'>
                    <ReactHighcharts config={this.props.data} ></ReactHighcharts>
                </div>
            </Grid.Column>
            );
    }
}

const styles = {
    headingText :{
        fontSize: 16,
        fontWeight: 400,
        color: '#666874',
        paddingBottom:20,
        paddingLeft: 5,
        textTransform: 'uppercase',
        fontFamily: 'Roboto',
    },
    heading :{
        color: '#af2d2d',
        borderBottom: '1px solid #c1c1c5',
        marginBottom: 20,
        marginLeft: 0,
        marginRight: 0,
    },
}

const mapStateToProps = state => {
    return {}
}

export default connect(mapStateToProps, {  })(Chart)



// WEBPACK FOOTER //
// ./src/components/Chart/index.js